import React from 'react'
import { object, bool, string } from 'prop-types'
import { css } from '@emotion/react'

import { formatPrice } from '@/utils/products'
import mediaQueries from '@/layout/media-queries'
import { VIEW_MODES } from '@/constants'

const priceInfoCss = (isCompact, viewMode) => (theme) =>
  css`
    font-size: 13px;
    font-weight: ${theme.font.bold};
    display: flex;
    align-items: center;
    margin-top: 10px;
    transition: margin-top 0.2s ease-out;

    ${mediaQueries.mediumScreen()} {
      ${isCompact ? `margin-top: 4px;` : `margin-top: 14px;`}
    }

    ${viewMode === VIEW_MODES.EMBEDDED &&
    `
    margin-top: 4px !important;
    `}
  `

const currencyCss = css`
  position: relative;
  bottom: 10px;
`
const priceCss = css`
  font-size: 28px;
`

const Payment = ({ payment, isCompact, viewMode }) => {
  return (
    <div css={priceInfoCss(isCompact, viewMode)}>
      <div
        css={css`
          margin-right: 8px;
        `}
      >
        <span css={currencyCss}>$</span>
        <span css={priceCss}>{formatPrice(payment.price)}</span>

        {payment.frequency === 'monthly' && <span> / mo,</span>}

        {payment.perAccount ? (
          <span> per agent</span>
        ) : (
          <span> per license</span>
        )}
      </div>
    </div>
  )
}

Payment.propTypes = {
  payment: object,
  isCompact: bool,
  viewMode: string,
}

export default Payment
